export interface AreaInitializer {
  id: number;
  localName: string;
  normalizedName: string;
  parentAreaId: number | null;
  parentArea: AreaInitializer | null;
}

export default class Area {
  public static PopularIds = [13, 14, 23, 26, 27, 40];

  public readonly id: number;
  public readonly localName: string;
  public readonly normalizedName: string;
  public readonly parentAreaId: number | null;
  public readonly parentArea: Area | null;

  constructor(init: AreaInitializer) {
    this.id = init.id;
    this.localName = init.localName;
    this.normalizedName = init.normalizedName;
    this.parentAreaId = init.parentAreaId;
    this.parentArea = init.parentArea && new Area(init.parentArea);
  }
}
